module.exports = __webpack_public_path__ + "images/Logo-HP-b1508aabf6205e02a4f2a906b05bedf5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/Logos/Logo-HP.svg
// module id = 18
// module chunks = 0